const fontType = {
    bold: 'Poppins-Bold',
    semiBold: 'Poppins-SemiBold',
    medium: 'Poppins-Medium',
    regular: 'Poppins-Regular',
    italic: 'Poppins-Italic',
}

export {
    fontType
}